import StylesTextFieldServiceInterface
  from '~/src/components/mui-wrappers/styled/text-field/styles/StylesTextFieldServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesTextFieldServiceStyleOne extends TemplateServiceStyleBase implements StylesTextFieldServiceInterface {
  public getComponentSx(): Record<string, unknown> {
    return {}
  }
}
